import styled from 'styled-components';
import { RowTable } from '../../../../func/components/Table';

const AfterBidInfo = ({ leaseinformation }: any) => {
  const array = JSON.parse(leaseinformation);
  const flattenedArray = array.flat();

  const data = [
    { key: '인도/인수책임', value: flattenedArray[0] },
    { key: '부대조건', value: flattenedArray[1] },
  ];

  return (
    <Container id="낙찰후인도/인수책임">
      <Block>
        <Title>낙찰 후 인도/인수 책임</Title>
        <RowTable data={data} titleWidth={110} />
      </Block>
    </Container>
  );
};

export default AfterBidInfo;

const Container = styled.div`
  width: 100%;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Spoqa Han Sans Neo;
  background-color: #fff;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;
